import PropTypes from 'prop-types';

const returnedItemProps = {
  item_id: PropTypes.number,
  qty: PropTypes.number,
  itemized_details: PropTypes.arrayOf(PropTypes.any),
  return_reason: PropTypes.shape({
    display_name: PropTypes.string,
    id: PropTypes.number,
  }),
};

const reasonCodeProps = {
  return_reason_code_id: PropTypes.number,
  reason_code: PropTypes.number,
  display_name: PropTypes.string,
  return_reason_settings_json: PropTypes.string,
  display_order: PropTypes.number,
};

const reasonCodesProps = {
  reason_category: PropTypes.string,
  is_nested: PropTypes.bool,
  nested: PropTypes.bool,
  return_reasons: PropTypes.arrayOf(PropTypes.shape(reasonCodeProps)),
};

export const itemProps = {
  blind_item: PropTypes.bool,
  brand: PropTypes.string,
  clearance_sale: PropTypes.bool,
  display_default_properties: PropTypes.bool,
  final_sale: PropTypes.bool,
  fulfillment_status: PropTypes.string,
  item_category: PropTypes.string,
  item_desc: PropTypes.string,
  item_gift: PropTypes.bool,
  item_gift_card: PropTypes.bool,
  item_id: PropTypes.number,
  item_name: PropTypes.string,
  item_price: PropTypes.number,
  item_qty: PropTypes.number,
  ltl: PropTypes.bool,
  orderInfoId: PropTypes.number,
  order_number: PropTypes.string,
  personalized: PropTypes.bool,
  product_id: PropTypes.string,
  product_image_url: PropTypes.string,
  product_sku: PropTypes.string,
  qty: PropTypes.number,
  refund_method: PropTypes.string,
  remaining_qty: PropTypes.number,
  repair_eligibility: PropTypes.bool,
  return_eligibility: PropTypes.bool,
  return_eligibility_message: PropTypes.string,
  return_reason_codes: PropTypes.arrayOf(PropTypes.shape(reasonCodesProps)),
  return_status: PropTypes.string,
  returned: PropTypes.bool,
  validate_return_options: PropTypes.bool,
};

export const returnLabelProps = {
  return_method: PropTypes.string,
  return_id: PropTypes.number,
  encrypted_return_id: PropTypes.string,
  rma_number: PropTypes.string,
  tracking_number: PropTypes.string,
  return_status: PropTypes.string,
  cancel_eligibility: PropTypes.bool,
  pssl: PropTypes.bool,
  number_of_items: PropTypes.number,
  returned_items: PropTypes.arrayOf(PropTypes.shape(returnedItemProps)),
  url: PropTypes.string,
  return_items: PropTypes.arrayOf(PropTypes.shape(itemProps)),
};
